import { render, staticRenderFns } from "./SalesContract.vue?vue&type=template&id=5150f566&scoped=true"
import script from "./SalesContract.vue?vue&type=script&lang=js"
export * from "./SalesContract.vue?vue&type=script&lang=js"
import style0 from "./SalesContract.vue?vue&type=style&index=0&id=5150f566&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150f566",
  null
  
)

export default component.exports